export var ErroresGlobal = []
export var ConsolaXQuery = ""; 
export var datosXML = null; 
export var TablaSimbolosXQuery = []

export function LimpiarErrores()
{
  ErroresGlobal = []
}